export const nationalityOptions = [
  { value: "Indian", label: "Indian" },
  { value: "NRI", label: "NRI" },
  // Existing 20 countries
  { value: "USA", label: "USA" },
  { value: "Canada", label: "Canada" },
  { value: "UK", label: "UK" },
  { value: "Australia", label: "Australia" },
  { value: "Germany", label: "Germany" },
  { value: "France", label: "France" },
  { value: "Italy", label: "Italy" },
  { value: "Spain", label: "Spain" },
  { value: "Russia", label: "Russia" },
  { value: "China", label: "China" },
  { value: "Japan", label: "Japan" },
  { value: "Brazil", label: "Brazil" },
  { value: "Mexico", label: "Mexico" },
  { value: "South Africa", label: "South Africa" },
  { value: "New Zealand", label: "New Zealand" },
  { value: "Singapore", label: "Singapore" },
  { value: "UAE", label: "UAE" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  // 50 additional countries
  { value: "Argentina", label: "Argentina" },
  { value: "Belgium", label: "Belgium" },
  { value: "Chile", label: "Chile" },
  { value: "Colombia", label: "Colombia" },
  { value: "Denmark", label: "Denmark" },
  { value: "Egypt", label: "Egypt" },
  { value: "Finland", label: "Finland" },
  { value: "Greece", label: "Greece" },
  { value: "Hungary", label: "Hungary" },
  { value: "Iceland", label: "Iceland" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Ireland", label: "Ireland" },
  { value: "Israel", label: "Israel" },
  { value: "Jordan", label: "Jordan" },
  { value: "Kenya", label: "Kenya" },
  { value: "Kuwait", label: "Kuwait" },
  { value: "Lebanon", label: "Lebanon" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Morocco", label: "Morocco" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "Norway", label: "Norway" },
  { value: "Oman", label: "Oman" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Peru", label: "Peru" },
  { value: "Philippines", label: "Philippines" },
  { value: "Poland", label: "Poland" },
  { value: "Portugal", label: "Portugal" },
  { value: "Qatar", label: "Qatar" },
  { value: "Romania", label: "Romania" },
  { value: "Saudi Arabia", label: "Saudi Arabia" },
  { value: "South Korea", label: "South Korea" },
  { value: "Sweden", label: "Sweden" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Thailand", label: "Thailand" },
  { value: "Turkey", label: "Turkey" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "United Kingdom", label: "United Kingdom" },
  { value: "United States", label: "United States" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Bhutan", label: "Bhutan" },
  { value: "Nepal", label: "Nepal" },
  { value: "Sri Lanka", label: "Sri Lanka" },
  { value: "Maldives", label: "Maldives" },
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Kazakhstan", label: "Kazakhstan" },
  { value: "Uzbekistan", label: "Uzbekistan" },
  { value: "Tajikistan", label: "Tajikistan" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan" },
  { value: "Turkmenistan", label: "Turkmenistan" },
  { value: "Iraq", label: "Iraq" },
  { value: "Syria", label: "Syria" },
  { value: "Yemen", label: "Yemen" },
  { value: "Philippines", label: "Philippines" }
];
